import * as React from 'react';
import { useDispatch } from 'react-redux';

import { TThunkDispatch } from '../../../types/redux';
import { SaveSearchButton } from './SaveSearchButton';
import { openSaveSearchModal } from '../../../actions/saveSearch';

export const SaveSearchButtonContainer: React.FC = () => {
  const dispatch = useDispatch<TThunkDispatch>();

  const handleClick = React.useCallback(() => {
    dispatch(openSaveSearchModal());
  }, [dispatch]);

  return <SaveSearchButton onClick={handleClick} />;
};

SaveSearchButtonContainer.displayName = 'SaveSearchButtonContainer';
